if (!customElements.get('picker-modal')) {
  customElements.define(
    'picker-modal',
    class PickerModal extends ModalDialog {
      constructor() {
        super();
        this.init();
      }

      init() {
        // Selectors
        this.display_row = this.querySelector('.picker-modal_product-row');
        this.view_switcher_btns = this.querySelectorAll('button.picker-modal_option-view-switch');
        this.radios = this.querySelectorAll('input[type="radio"]');
        this.apply_btn = this.querySelector('.picker-modal_apply');
        this.option_tabs = this.querySelectorAll('.picker-modal_options');

        // Events
        this.view_switcher_events = [];
        this.view_switcher_btns.forEach((btn) => {
          const handler = this.switchView.bind(this);
          btn.addEventListener('click', handler);
          this.view_switcher_events.push({ btn, handler });
        });
        this.radio_events = [];
        this.radios.forEach((radio) => {
          const handler = this.updateSelection.bind(this);
          radio.addEventListener('change', handler);
          this.radio_events.push({ radio, handler });
        });
        this.apply_btn_handler = this.applySelection.bind(this);
        this.apply_btn.addEventListener('click', this.apply_btn_handler);
        this.content_updated_handler = this.contentUpdated.bind(this);
        this.addEventListener('content-updated', this.content_updated_handler);
      }

      connectedCallback() {
        if (this.moved) return; // super.connectedCallback() re-triggers this method, but sets moved = true
        super.removeAllOthers();
        super.connectedCallback();
      }

      disconnectedCallback() {
        if (this.moving) return; // avoid destroying, if we're simply moving the element in the DOM
        this.destroy();
      }

      destroy() {
        this.view_switcher_events.forEach(({ btn, handler }) => {
          btn.removeEventListener('click', handler);
        });
        this.radio_events.forEach(({ radio, handler }) => {
          radio.removeEventListener('change', handler);
        });
        this.apply_btn.removeEventListener('click', this.apply_btn_handler);
        this.removeEventListener('content-updated', this.content_updated_handler);
      }

      contentUpdated() {
        this.destroy();
        this.init();
      }

      show(opener) {
        this.switchView({
          target: opener,
        });
        super.show();
      }

      /**
       * @param {Event|Object} data - JS event or Object containing button as 'target' property
       */
      switchView(data) {
        const btn = data.target;
        const targetIndex = btn.getAttribute('data-option-position');

        // Change button active class
        this.view_switcher_btns.forEach((element) => {
          if (element.getAttribute('data-option-position') === targetIndex) {
            element.classList.add('btn-primary');
            element.classList.remove('btn-secondary');
          } else {
            element.classList.remove('btn-primary');
            element.classList.add('btn-secondary');
          }
        });

        // Change options tab view
        this.option_tabs.forEach((element) => {
          element.classList.remove('active-tab');
        });
        const targetTab = this.querySelector(`.picker-modal_options[data-option-position="${targetIndex}"]`);
        targetTab.classList.add('active-tab');
      }

      applySelection() {
        const productInfo = document.querySelector('product-info');
        const optionValues = this.getOptionValues();
        productInfo.handleOptionValueChange({
          data: {
            event: {
              target: productInfo,
            },
            target: productInfo,
            selectedOptionValues: optionValues,
          },
        });
        this.hide();
      }

      updateDisplay(activeRadio) {
        const targetIndex = activeRadio.parentElement.getAttribute('data-option-position');
        const label = activeRadio.nextElementSibling;
        const variantImgUrl = activeRadio.dataset.variantImage;
        const optionValue = label.querySelector('.picker-modal_option-value');
        const price = label.querySelector('.picker-modal_option-price');

        if (variantImgUrl) {
          this.display_row.querySelector('.picker-modal_product-image').setAttribute('src', variantImgUrl);
        }
        if (optionValue) {
          this.display_row.querySelector(
            `[data-option-position="${targetIndex}"] .picker-modal_product-option-value`
          ).innerHTML = optionValue.innerHTML;
        }
        if (price) {
          this.display_row.querySelector('.picker-modal_product-price').innerHTML = price.innerHTML;
        }
      }

      fetchOptions() {
        const currentModal = this;
        const productInfo = document.querySelector('product-info');
        const url = productInfo.dataset.url;
        const sectionID = productInfo.dataset.section;
        const optionValues = this.getOptionValues();
        fetch(`${url}?section_id=${sectionID}&option_values=${optionValues.join(',')}`)
          .then((response) => {
            if (!response.ok) throw new Error('Network response was not ok');
            return response.text();
          })
          .then((html) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newModal = doc.querySelector('picker-modal');

            if (newModal) {
              const currentContent = currentModal.querySelector('.picker-modal_options:not(.active-tab)');
              if (currentContent) {
                const targetIndex = currentContent.getAttribute('data-option-position');
                const newContent = newModal.querySelector(
                  `.picker-modal_options[data-option-position="${targetIndex}"]`
                );
                if (newContent) {
                  currentContent.innerHTML = newContent.innerHTML;
                  this.contentUpdated();
                }
              }
            } else {
              console.warn('Modal wrapper not found in fetched HTML.');
            }
          })
          .catch((error) => {
            console.error('Error updating picker modal:', error);
          });
      }

      updateSelection(e) {
        const activeRadio = e.target;
        this.updateDisplay(activeRadio);
        this.fetchOptions();
      }

      getOptionValues() {
        const staticOptions = this.querySelectorAll('.picker-modal_static-options');
        const dynamicOptions = this.querySelectorAll('.picker-modal_options input[type="radio"]:checked');
        const options = [...staticOptions, ...dynamicOptions];
        return options.map((option) => encodeURIComponent(option.value));
      }
    }
  );
}
